// extracted by mini-css-extract-plugin
export default {"submit-button":"AddTeam_submit-button__KTKWN","cancel-button":"AddTeam_cancel-button__R3es1"};